import {CatalogReference} from '@wix/auto_sdk_ecom_current-cart';
import {CatalogReferenceModel} from './CatalogReference.model';
import {ItemSource} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class SourceModel {
  public catalogReference: CatalogReferenceModel;

  constructor(params: SourceModel) {
    this.catalogReference = params.catalogReference;
  }

  public static fromCartV1(catalogReference: CatalogReference) {
    return new SourceModel({
      catalogReference: CatalogReferenceModel.fromCartV1(catalogReference),
    });
  }

  public static fromCartV2(source: ItemSource): SourceModel {
    return new SourceModel({
      catalogReference: CatalogReferenceModel.fromCartV2(source.catalogReference),
    });
  }
}
